import { QueryObserverBaseResult, useQuery } from "react-query";
import api from "../../../client";
import { queryKeys } from "../../../query";
import { UserContactListResponseData } from "../../../types/user";

export const getData = async () => {
  const { data } = await api.get<UserContactListResponseData>(`/user/contact`);

  return data;
};

export const useUserContacts =
  (): QueryObserverBaseResult<UserContactListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.userContacts(), () =>
      getData(),
    );
    return { data, ...props };
  };
